<div id="app">
    @if (!hasError() && !isLoading()) {
        <aside>
            <app-sidebar></app-sidebar>
        </aside>
    }

    <div id="layout" [ngClass]="isSidebarCollapsed() ? 'collapsed-sidebar' : 'expanded-sidebar'">
        @if (!hasError() && !isLoading()) {
            <div id="header-container">
                <app-header></app-header>
            </div>
        }

        @if (!isUnauthorized()) {
            <div id="breadcrumbs-container">
                <app-breadcrumbs></app-breadcrumbs>
            </div>
        }

        <main id="content">
            @if (isLoading()) {
                <loader [global]="true"></loader>
            }

            @if (!isUnauthorized()) {
                <div [style.hidden]="isLoading()">
                    <router-outlet></router-outlet>
                </div>
            }

            @if (hasError() && !isUnauthorized()) {
                <app-error-page></app-error-page>
            }
            @if (isUnauthorized()) {
                <app-unauthorized-page></app-unauthorized-page>
            }
        </main>

        <div id="app-footer">
            <app-footer></app-footer>
        </div>
    </div>

    <div id="mobile-footer" class="no-print">
        <app-mobile-menu></app-mobile-menu>
    </div>
</div>

<p-toast
    id="error-messages-anchor"
    position="top-center"
    [key]="toasterPositions.TOP_CENTER"
    [preventOpenDuplicates]="true">
</p-toast>
<p-toast
    id="warning-success-messages-anchor"
    position="bottom-right"
    [key]="toasterPositions.BOTTOM_RIGHT"
    [preventOpenDuplicates]="true">
</p-toast>
